import React from 'react';
import HeroSection from '../components/modern/HeroSection';
import FeaturesSection from '../components/modern/FeaturesSection';
import SimulatorsSection from '../components/modern/SimulatorsSection';
import ArticlesSection from '../components/modern/ArticlesSection';
import NewsletterSection from '../components/modern/NewsletterSection';
import AppSection from '../components/modern/AppSection';
import SEO, { organizationJsonLd, breadcrumbJsonLd } from '../components/SEO';

const ModernHome = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEO
        title="Guides experts et simulateurs freelance 2026"
        description="Guides experts, simulateurs gratuits et articles de référence pour freelances et entrepreneurs. Données officielles 2026. URSSAF, fiscalité, statuts juridiques."
        path="/"
        jsonLd={organizationJsonLd}
      />
      <HeroSection />
      <FeaturesSection />
      <AppSection />
      <SimulatorsSection />
      <ArticlesSection />
      <NewsletterSection />
    </div>
  );
};

export default ModernHome;